import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (postalCode) => `${API_URL}/api/v1/crm/planbuilder/search?zipCode=${postalCode}`;

const getPlans = async (postalCode) => await apiRequest(getUrl(postalCode), "get");

export default getPlans;

